import http from '../../services/http'

import auth from '../../services/auth.js'
import { make } from 'vuex-pathify'

const state = {
  config: {
    id: 0,
    welcomeText: '',
    hasValidEdition: false,
    edition: {
      edition: '',
      description: '',
      participationAdhesion: 0,
      participationParEleve: 0,
      singulisTravauxDescription: '',
      singulisTravauxNoteLabel: '',
      omnibusTravauxDescription: '',
      inscriptionStart: new Date(0),
      inscriptionEnd: new Date(0),
      singulisContestStart: new Date(0),
      singulisContestEnd: new Date(0),
      singulisDepotEnd: new Date(0),
      omnibusDepotEnd: new Date(0),
      singulisDocs: [],
      omnibusDocs: [],
    },
  },
  inscription: {
    id: 0,
    isValid: false,
    hasPaid: false,
    billStatus: '',
    nbClasses: 0,
  },
  doSingulis: false,
  doOmnibus: false,
  paymentMode: '',
  classes: [],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  async loadClasses ({ dispatch }) {
    const { data: classes } = await http.api.get('/participant/classes')
    let doSingulis = false
    let doOmnibus = false
    classes.list.forEach(one => {
      if (one.doSingulis) doSingulis = true
      if (one.doOmnibus) doOmnibus = true

      try {
        one.singulisDate = new Date(one.singulisDate)
        if (one.singulisDate.getTime() < 0) {
          one.singulisDate = null
        }
      } catch (e) {}
    })

    auth.setDoSingulis(doSingulis)
    auth.setDoOmnibus(doOmnibus)

    console.log('doSingulis', doSingulis)
    console.log('doOmnibus', doOmnibus)

    dispatch('setDoSingulis', doSingulis)
    dispatch('setDoOmnibus', doOmnibus)
    dispatch('setClasses', classes.list)
  },
  async loadInscription ({ dispatch }) {
    const { data: insc } = await http.api.get('/participant/inscription')
    insc.nbClasses = 0
    dispatch('setPaymentMode', insc.paymentMode)
    dispatch('setInscription', insc)
  },
  async init ({ dispatch }) {
    try { await dispatch('loadInscription') } catch (e) {}

    const { data } = await http.api.get('/resource/admin-artifex')
    console.log(data)
    try { data.edition.inscriptionStart = new Date(data.edition.inscriptionStart) } catch (e) {}
    try { data.edition.inscriptionEnd = new Date(data.edition.inscriptionEnd) } catch (e) {}
    try { data.edition.singulisContestStart = new Date(data.edition.singulisContestStart) } catch (e) {}
    try { data.edition.singulisContestEnd = new Date(data.edition.singulisContestEnd) } catch (e) {}
    try { data.edition.singulisDepotEnd = new Date(data.edition.singulisDepotEnd) } catch (e) {}
    try { data.edition.omnibusDepotEnd = new Date(data.edition.omnibusDepotEnd) } catch (e) {}
    try { data.edition.singulisTravauxDescription = data.edition.singulisTravauxDescription.replace(/\n/g, '<br/>') } catch (e) {}
    try { data.edition.omnibusTravauxDescription = data.edition.omnibusTravauxDescription.replace(/\n/g, '<br/>') } catch (e) {}
    dispatch('setConfig', data)

    try { await dispatch('loadClasses') } catch (e) {}
  },

}

const getters = {
  nbClasses: state => state.classes.length,
  doSingulis: state => state.doSingulis,
  doOmnibus: state => state.doOmnibus,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
